import { render, staticRenderFns } from "./MainLayout.vue?vue&type=template&id=552bf475&scoped=true"
import script from "./MainLayout.vue?vue&type=script&lang=js"
export * from "./MainLayout.vue?vue&type=script&lang=js"
import style0 from "./MainLayout.vue?vue&type=style&index=0&id=552bf475&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@osgfe/builder-plugin-vue2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "552bf475",
  null
  
)

export default component.exports